import Vue from 'vue';
import confirmV3 from '../components/ui/confirm-v3/index';

Vue.use(confirmV3);
